import React, { ReactNode } from "react";

export type DailyTableColumn<R> = {
    key: string;
    header: string;
    numeric?: boolean;
    render: (row: R) => ReactNode;
};

type Props<R> = {
    caption: string;
    columns: DailyTableColumn<R>[];
    rows: R[];
    rowKey: (row: R) => string;
    emptyMessage: string;
};

/** A plain data table: captioned, column-scoped headers, and an explicit empty row. */
export const DailyTable = <R,>({ caption, columns, rows, rowKey, emptyMessage }: Props<R>): React.ReactElement => (
    <div className="daily-table__scroll">
        <table className="daily-table">
            <caption className="daily-table__caption">{caption}</caption>
            <thead>
                <tr>
                    {columns.map((column) => (
                        <th key={column.key} scope="col" className={column.numeric === true ? "is-numeric" : undefined}>
                            {column.header}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.length === 0 ? (
                    <tr>
                        <td colSpan={columns.length} className="daily-table__empty">{emptyMessage}</td>
                    </tr>
                ) : rows.map((row) => (
                    <tr key={rowKey(row)}>
                        {columns.map((column) => (
                            <td key={column.key} className={column.numeric === true ? "is-numeric" : undefined}>
                                {column.render(row)}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);
